module.exports = __webpack_public_path__ + "static/media/wifi-solid.55e292cc.svg";